import dateFormat, { formatDateTime } from "../../../../../utils/dateFormat";

export const recordDetailsheader = (isFinance) => {
  if (isFinance) {
    return ["Name", "Inquire by", "Client", "Branch", "Have CourtCase?"];
  }

  return [
    "Name",
    "Date Locked",
    "Inquire by",
    "Affiliate",
    "Branch",
    "Have CourtCase?",
  ];
};

export const recordDetailsBody = (
  object,
  isFinance,
  userLoggedin,
  courtCases,
) => {
  console.log("ob", object);
  if (!object) return;

  const { firstName, middleName, lastName, alias, lockedTo } = object || {};
  console.log("lockl", lockedTo);
  const dateDisplay = object?.lockedDateString
    ? formatDateTime(object?.lockedDateString)
    : dateFormat(object.updatedAt);

  if (isFinance) {
    return [
      [
        object?.company
          ? object?.company
          : `${firstName} ${middleName || ""} ${lastName} ${alias || ""}`,
        `${userLoggedin[0]?.firstName || ""} ${
          userLoggedin[0]?.middleName || ""
        } ${userLoggedin[0]?.lastName || ""}`,
        userLoggedin[0]?.affiliate?.name || "None",
        userLoggedin[0]?.branch?.name || "None",
        courtCases[0]?.caseNumber ? "Yes" : "No",
      ],
    ];
  }

  const recordDetailsBody = [
    [
      object?.company
        ? object?.company
        : `${firstName} ${middleName || ""} ${lastName} ${alias || ""}`,
      dateDisplay,
      // lockedTo
      //   ? `${lockedTo.firstName || ""} ${lockedTo.middleName || ""} ${
      //       lockedTo.lastName || ""
      //     }`
      //   : "None",
      lockedTo
        ? [lockedTo.firstName, lockedTo.middleName, lockedTo.lastName]
            .filter(Boolean)
            .join(" ") || `${lockedTo.id}`
        : "None",
      lockedTo?.affiliate?.name || "None",
      lockedTo?.branch?.name || "None",
      courtCases[0]?.caseNumber ? "Yes" : "No",
    ],
  ];

  return recordDetailsBody;
};
